import { render, staticRenderFns } from "./addApproveNode.vue?vue&type=template&id=22c54932&scoped=true&lang=pug"
import script from "./addApproveNode.vue?vue&type=script&lang=js"
export * from "./addApproveNode.vue?vue&type=script&lang=js"
import style0 from "./addApproveNode.vue?vue&type=style&index=0&id=22c54932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c54932",
  null
  
)

export default component.exports